/** A client's action planning setting, mirroring the backend's ActionPlanningModes. */
export type ActionPlanningModeCode = 'DISABLED' | 'ENABLED' | 'ENABLED_WITH_TAKE_ACTION';

/** Whether action planning (the ACTION module, My action plans, Take Action) is available to the client. */
export const isActionPlanningEnabled = (mode: ActionPlanningModeCode | null | undefined): boolean =>
  !!mode && mode !== 'DISABLED';

/** Whether the client also shows the Take Action buttons on the Engage Analytics summary report. */
export const isAnalyticsTakeActionShown = (mode: ActionPlanningModeCode | null | undefined): boolean =>
  mode === 'ENABLED_WITH_TAKE_ACTION';
